var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { useTheme } from '@citrus/user';
import { DragNDrop as Component } from './DragNDrop.styled';
import DragNDropDraggableItem from './DragNDropDraggableItem';
import DragNDropDroppedItem from './DragNDropDroppedItem';
import { Droparea } from '@citrus/droparea';
import { getAutomation, getDebug } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
var VERSION = 'unknown';
var DragNDrop = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, dropArea = _a.dropArea, id = _a.id, renderPlaceholder = _a.renderPlaceholder, _c = _a.__TYPE, TYPE = _c === void 0 ? 'DragNDrop' : _c, other = __rest(_a, ["automationId", "children", "className", "css", "dropArea", "id", "renderPlaceholder", "__TYPE"]);
    var isCitron = useTheme().citrus2022;
    useEffect(function () {
        if (isCitron)
            window.document.body.classList.add('citron');
        return function () { return window.document.body.classList.remove('citron'); };
    }, [isCitron]);
    var classes = cx(isCitron ? 'citron-drag-n-drop' : 'pcty-drag-n-drop', (_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    return (React.createElement(Component, __assign({ className: classes, id: id, ref: ref }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)),
        _renderPlaceholder(renderPlaceholder, children, dropArea),
        children));
});
var _renderPlaceholder = function (renderPlaceholder, children, dropArea) {
    if (dropArea && !!renderPlaceholder && (!children || React.Children.toArray(children).length <= 0)) {
        var placeholder = renderPlaceholder();
        if (typeof placeholder === 'string') {
            return React.createElement(Droparea, { embedded: true, large: true, placeholder: true, placeholderText: placeholder });
        }
        return (React.createElement(Droparea, { embedded: true, large: true }, placeholder));
    }
};
DragNDrop.defaultProps = {
    __TYPE: 'DragNDrop',
};
export default Object.assign(DragNDrop, {
    DraggableItem: DragNDropDraggableItem,
    DroppedItem: DragNDropDroppedItem,
});
